export default __webpack_public_path__ + "../staticImages/zauberer_02-260.png";